import { Component, OnInit } from '@angular/core';

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AppService } from './app.service';
import { DialogEditUdstyrComponent } from './dialog-edit-udstyr.component';
import { DialogOpretUdstyrComponent } from './dialog-opret-udstyr.component';
import { DialogShowFullImageComponent} from './dialog-show-full-image.component'

@Component({
  selector: 'app-mygear',
  templateUrl: './mygear.component.html',
  styleUrls: ['./mygear.component.css']
})
export class MygearComponent implements OnInit {



  constructor(public dialog: MatDialog, private serv: AppService, private router: Router, private _snackBar: MatSnackBar) {
    
   }

   rows = []



  ngOnInit(): void {
    this.serv.isLoggedIn$.subscribe(x => {
      if (!x) {
        console.log("!x mygear")
        this.router.navigate(['/'])

      }
    })

    this.serv.getMyGear().subscribe(ret => {
      this.rows = ret['rows']
    })
  }


  

  openAddGearDialog() {
    const dialogRef = this.dialog.open(DialogOpretUdstyrComponent, {width: "475px", maxHeight: '90vh' })

    dialogRef.afterClosed().subscribe(ret => {
      if (ret) {
        this._snackBar.open("Udstyr tilføjet!", "Luk", {
          duration: 3000,
        });
        this.ngOnInit()
      }
    })
  }


  openEditGearDialog(id: number) {
    const dialogRef = this.dialog.open(DialogEditUdstyrComponent, {width: "475px", maxHeight: '90vh', data: {id: id} })

    dialogRef.afterClosed().subscribe(ret => {
      if (ret) {
        this._snackBar.open("Udstyr redigeret!", "Luk", {
          duration: 3000,
        });
        this.ngOnInit()
      }
    })
  }

  deleteGear(id: number) {
    if (confirm("Er du sikker på at du vil dette udstyr?")) {
      this.serv.deleteGear(id).subscribe(ret => {
        if (ret['result']) {
          this._snackBar.open("Udstyr slettet!", "Luk", {
            duration: 3000,
          });
        }
        this.ngOnInit()
      })
    } 
  }

  showFullImage(filename: string) {
    const dialogRef = this.dialog.open(DialogShowFullImageComponent, {maxWidth: '90%', maxHeight: '90vh', data: {filename: filename}})
  }

}
